import BaseStore from './BaseStore'

export class WorkflowProcessHistoryStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'workflow_process_histories'
  }
}

export default new WorkflowProcessHistoryStore()


// WEBPACK FOOTER //
// ./src/stores/WorkflowProcessHistoryStore.js